export enum UploadTestIds {
  FileInput = 'UploadAssetsFileInput',
  FolderInput = 'UploadAssetsFolderInput',
  SelectExistingDirectory = 'UploadPathSelectExistingDirectory',
  SelectNewDirectory = 'UploadPathSelectCustomPath',
  SelectImportedPath = 'UploadPathSelectImportedPath',
  PathDropdownInput = 'UploadPathDropdownInput',
  PathCustomPathInput = 'UploadPathCustomPathInput',
  ExpandMetadata = 'AddAssetMetadataExpand',
  AssetsMetadataInput = 'UploadMetadataJsonInput',
  AddAssetMetadataButton = 'UploadMetadataAddButton',
  SubmitButton = 'UploadAssetsSubmitButton',
  ViewUploadedModelsButton = 'ViewUploadedModelsButton',
  UploadResultsOverlay = 'UploadResultsOverlay',
  UploadDrawer = 'UploadDrawer',
  UploadDependencyButton = 'UploadDependencyButton',
  UploadSummary = 'UploadSummary',
  UploadCloseButton = 'UploadCloseButton',
  UploadList = 'UploadList',
  UploadOverallPercent = 'UploadOverallPercent',
  UploadOverallProgress = 'UploadOverallProgress',
  UploadSuccessCount = 'UploadSuccessCount',
  UploadErrorCount = 'UploadErrorCount',
  UploadRow = 'UploadRow',
  UploadRowProgressBar = 'UploadRowProgressBar',
  UploadRowProgress = 'UploadRowProgress',
  UploadRowErrorMessage = 'UploadRowErrorMessage',
  UploadRowTraceId = 'UploadRowTraceId',
  UploadRowStatusText = 'UploadRowStatusText',
  UploadStatusModal = 'UploadStatusModal',
  UploadStatusTabAll = 'UploadStatusTabAll',
  UploadStatusTabSuccess = 'UploadStatusTabSuccess',
  UploadStatusTabError = 'UploadStatusTabError',
  UploadStatusTabQueued = 'UploadStatusTabQueued',
  UploadStatusExportButton = 'UploadStatusExportButton',
  UploadStatusExportCurrent = 'UploadStatusExportCurrent',
  UploadStatusExportAll = 'UploadStatusExportAll',
  UploadStatusExportCsv = 'UploadStatusExportCsv',
  UploadStatusExportXlsx = 'UploadStatusExportXlsx',
  UploadStatusEmptyState = 'UploadStatusEmptyState',
  UploadTableRow = 'UploadTableRow',
  UploadFolderRow = 'UploadFolderRow',
}
